import { Injectable } from '@angular/core';
import { AppState } from '@app/definitions/interfaces';

@Injectable({
    providedIn: 'root'
})
export class StateService {
    constructor() {}

    chageAppState(appSate: AppState) {
        const stateData = JSON.stringify(appSate);
        localStorage.setItem('appState', stateData);
    }

    get appState(): AppState {
        const appState = JSON.parse(localStorage.getItem('appState'));
        return appState;
    }
}
